<template>
  <div
    :class="$style.countryPageContent"
  >
    <div :class="$style['col-1']">
      <img
        :src="country.flag"
        :alt="`${country.name}'s Flag`"
      >
    </div>
    <div
      :class="[$style['col-2'],$style.countryDetails]"
    >
      <h1>{{ country.name }}</h1>
      <div
        :class="$style.moreInfo"
      >
        <div
          :class="$style['col-1']"
        >
          <p><b>Native Name: </b>{{ country.nativeName }}</p>
          <p><b>Population: </b>{{ country.population }}</p>
          <p><b>Region: </b>{{ country.region }}</p>
          <p><b>Sub Region: </b>{{ country.subregion }}</p>
          <p><b>Capital: </b>{{ country.capital }}</p>
        </div>
        <div
          :class="$style['col-2']"
        >
          <p><b>Top Level Domain: </b>{{ country.capital }}</p>
          <p>
            <b>Currencies: </b>
            <template v-for="(_, idx) in country.currencies">
              {{ formatArr(idx, country.currencies) }}
            </template>
          </p>
          <p>
            <b>Language: </b>
            <template v-for="(_, idx) in country.languages">
              {{ formatArr(idx, country.languages) }}
            </template>
          </p>
        </div>
      </div>
      <BorderCountries
        :class="$style.countryBorders"
        :border-countries="country.borders"
      />
    </div>
  </div>
</template>

<script>
import BorderCountries from '@/components/BorderCountriesList.vue';

export default {
  components: {
    BorderCountries,
  },
  props: {
    country: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const formatArr = (idx, arr) => {
      const lastIdx = arr.length - 1;
      return idx === lastIdx ? arr[idx].name : `${arr[idx].name}, `;
    };
    return {
      formatArr,
    };
  },
};
</script>

<style lang="sass" module>
@import '@/assets/scss/_shared'

.countryPage
  max-width: 25rem
  margin: 0 auto
  @include screenMedium
    max-width: unset

.countryPageContent
  margin-top: clamp(4rem, 3vw, 5rem)
  position: relative
  @include screenMedium
    display: flex
    justify-content: space-between
    align-items: center

    > .col-1
      width: 50%
      > img
        width: 100%
        max-width: unset
    > .col-2
      width: 45%

  > .col-1
    > img
      display: block
      width: 100%

.countryDetails
  margin-top: 1rem
  @include screenMedium
    margin-top: unset
  > h1
    font-size: clamp(1.38rem, 4vw, 2rem)
    font-weight: 800
    margin-bottom: .4em
  .moreInfo
    @include screenLarge
      display: flex
      align-items: flex-start
      justify-content: space-between
    .col-2
      margin-top: 1.5em
      @include screenLarge
        margin-top: unset
    p
      font-weight: 300
    p > b
      font-weight: 600
      margin-right: .3rem

.countryBorders
  margin-top: 2rem
  width: 100%
  display: flex
  align-items: center
  justify-content: flex-start
  flex-flow: row wrap
  gap: 1.25rem
  @include screenMediumOnly
    position: absolute
    left: 50%
    transform: translate(-50%, 2rem)
    justify-content: space-between

  > li
    list-style: none
</style>
